import { render, staticRenderFns } from "./PopupPush.vue?vue&type=template&id=09171bf2"
import script from "./PopupPush.vue?vue&type=script&lang=js"
export * from "./PopupPush.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports